import RequestHandler from "./RequestHandler";

function MeasurementsAPI() {
    const baseMeasurementsAPI = "measurements";

    async function getMeasurements(filters = {}) {
        try {
            const result = await RequestHandler.post(
                `${baseMeasurementsAPI}/group`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function createMeasurements(measurement) {
        try {
            const result = await RequestHandler.post(
                `${baseMeasurementsAPI}/`,
                measurement
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getMeasurementsDetails(
        measurementsPerPage,
        criteria,
        offset = 0,
        filters
    ) {
        try {
            const skip = offset * measurementsPerPage;
            const result = await RequestHandler.post(
                `${baseMeasurementsAPI}/details?skip=${skip}&take=${measurementsPerPage}`,
                { criteria, filters }
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteMeasurement(id) {
        try {
            const result = await RequestHandler.remove(
                `${baseMeasurementsAPI}/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteBulkMeasurements(ids) {
        try {
            const result = await RequestHandler.remove(
                `${baseMeasurementsAPI}`,
                ids
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function syncLocal(reqData) {
        try {
            const result = await RequestHandler.post(
                `${baseMeasurementsAPI}/bulk`,
                reqData
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getMeasurements,
        getMeasurementsDetails,
        deleteMeasurement,
        deleteBulkMeasurements,
        syncLocal,
        createMeasurements,
    };
}

export default MeasurementsAPI();
